import React from 'react';
function ImageReplace({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.5 12.5v5c0 .833.5 2.5 2.5 2.5h12c.833 0 2.5-.5 2.5-2.5v-5M12 16V4.5m-3.5 3L12 4l3.5 3.5"
      />
    </svg>
  );
}

export default ImageReplace;
